
import { Component, Prop, Vue } from 'vue-property-decorator'

import SvgIcon from '@/components/SvgIcon.vue'

@Component({
  components: {
    SvgIcon
  }
})
export default class ErrorReportDialog extends Vue {
  @Prop() shouldShow!: boolean
  @Prop({ default: '' }) src!: string
}
